import {
  Box,
  FormHelperText,
  FormControl,
  Typography,
  ToggleButton as ToggleButtonMui,
  ToggleButtonProps,
} from '@mui/material';
import { Check } from '@mui/icons-material';
import { useState } from 'react';

type Props = {
  label: string;
  error?: boolean;
  helperText?: string;
  onChange: (value: boolean) => void;
  value: boolean;
  buttonProps?: Omit<ToggleButtonProps, 'value' | 'selected' | 'onChange'>;
};

const SimpleToggleButton = ({
  label,
  helperText = '',
  onChange,
  value,
  error = false,
  buttonProps = {}
}: Props) => {
  const [checked, setChecked] = useState(value)

  const toggleChecked = () => {
    const newValue = !checked;
    setChecked(newValue);
    onChange(newValue);
  }

  return (
    <FormControl error={error}>
      <Box display="flex" alignItems="center" gap={1}>
        <ToggleButtonMui
          value="check"
          selected={checked}
          onChange={toggleChecked}
          {...buttonProps}
        >
          <Check />
        </ToggleButtonMui>
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {label}
          </Typography>
          {helperText && <FormHelperText sx={{ mx: 0 }}>{helperText}</FormHelperText>}
        </Box>
      </Box>
    </FormControl>
  );
};


export default SimpleToggleButton;